import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const ReceiptListPage = lazy(() =>
  import("@/modules/finance").then((m) => ({ default: m.ReceiptListPage })),
);
const ReceiptDetailPage = lazy(() =>
  import("@/modules/finance").then((m) => ({ default: m.ReceiptDetailPage })),
);
const PaymentListPage = lazy(() =>
  import("@/modules/finance").then((m) => ({ default: m.PaymentListPage })),
);
const PaymentDetailPage = lazy(() =>
  import("@/modules/finance").then((m) => ({ default: m.PaymentDetailPage })),
);
const TransactionListPage = lazy(() =>
  import("@/modules/finance").then((m) => ({ default: m.TransactionListPage })),
);
const DebtReportListPage = lazy(() =>
  import("@/modules/finance").then((m) => ({ default: m.DebtReportListPage })),
);
const DebtReportDetailPage = lazy(() =>
  import("@/modules/finance").then((m) => ({ default: m.DebtReportDetailPage })),
);

export const financeRoutes: RouteObject[] = [
  {
    element: (
      <RequirePermissions codes={[PermissionCodes.FinTransactionList]} />
    ),
    children: [
      {
        path: "fin/transactions",
        element: (
          <LazyPage>
            <TransactionListPage />
          </LazyPage>
        ),
      },
    ],
  },
  {
    element: (
      <RequirePermissions codes={[PermissionCodes.FinDebtReport]} />
    ),
    children: [
      {
        path: "fin/debt-report",
        element: (
          <LazyPage>
            <DebtReportListPage />
          </LazyPage>
        ),
      },
      {
        path: "fin/debt-report/:partnerCode",
        element: (
          <LazyPage>
            <DebtReportDetailPage />
          </LazyPage>
        ),
      },
    ],
  },
  {
    element: (
      <RequirePermissions
        codes={[PermissionCodes.FinReceiptList, PermissionCodes.FinReceiptManage]}
        match="any"
      />
    ),
    children: [
      {
        path: "fin/receipts",
        element: (
          <LazyPage>
            <ReceiptListPage />
          </LazyPage>
        ),
      },
      {
        path: "fin/receipts/new",
        element: (
          <LazyPage>
            <ReceiptListPage />
          </LazyPage>
        ),
      },
      {
        path: "fin/receipts/:receiptNo",
        element: (
          <LazyPage>
            <ReceiptDetailPage />
          </LazyPage>
        ),
      },
      {
        path: "fin/receipts/:receiptNo/edit",
        element: (
          <LazyPage>
            <ReceiptDetailPage />
          </LazyPage>
        ),
      },
    ],
  },
  {
    element: (
      <RequirePermissions
        codes={[PermissionCodes.FinPaymentList, PermissionCodes.FinPaymentManage]}
        match="any"
      />
    ),
    children: [
      {
        path: "fin/payments",
        element: (
          <LazyPage>
            <PaymentListPage />
          </LazyPage>
        ),
      },
      {
        path: "fin/payments/new",
        element: (
          <LazyPage>
            <PaymentListPage />
          </LazyPage>
        ),
      },
      {
        path: "fin/payments/:paymentNo",
        element: (
          <LazyPage>
            <PaymentDetailPage />
          </LazyPage>
        ),
      },
      {
        path: "fin/payments/:paymentNo/edit",
        element: (
          <LazyPage>
            <PaymentDetailPage />
          </LazyPage>
        ),
      },
    ],
  },
];
